/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import request from './request';

export default class Model {
  constructor(url) {
    this.url = url;
  }

  async sendDataAndGetNew(data) {
    const lastRequestId = Symbol('lastRequestId');
    this.lastRequestId = lastRequestId;

    const newData = await this.sendAndGet(data);

    if (this.lastRequestId === lastRequestId) {
      return newData;
    }
    return null;
  }

  async sendAndGet(data) {
    const formData = new FormData();
    this.fillFormData(formData, data);

    const response = await request(this.url, 'POST', formData);
    const responseData = await response.text();
    return responseData ? JSON.parse(responseData) : '';
  }

  fillFormData(formData, data, parentKey) {
    let formDataKey;

    for (const key in data) {
      formDataKey = (parentKey === undefined ? key : `${parentKey}[${key}]`);

      if (typeof data[key] === 'object') {
        this.fillFormData(formData, data[key], formDataKey);
      } else {
        formData.append(formDataKey, data[key]);
      }
    }
  }
}
